import React, { useState, useEffect } from 'react';
import { faSearch, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CardBody, Input, InputGroup, InputGroupText } from 'reactstrap';

import style from './Focuses.style';

import FocustItems from './FocusItems/FocustItems';
import { clone } from '../../../../../Services/schedule';
import { deleteData, fetchDataAgnostic, postDataAgnostic, putData } from '../../../../../Services/dataApi';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { toast } from 'react-toastify';

function Focuses({ dContext, windowWidth }) {
  const [newFocus, setNewFocus] = useState({ name: '' });
  const [nameToSearch, setNameToSearch] = useState('');
  const [focuses, setFocuses] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const { getTokenSilently, loginWithRedirect } = useAuth0();
  // Alert functionality replaced with toast
  const widthToSwitchToMobile = 700;

  useEffect(() => {
    getFocuses();
  }, []);

  const getFocuses = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/focuses',
          { pk_Department: dContext.department.pk_Department },
          formatBearerToken(token),
        )
          .then((results) => {
            setFocuses(results.data);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const filterFocuses = (focuses) => {
    const newFilters = { ...focuses };
    Object.keys(focuses).forEach((key) => {
      const focus = focuses[key];
      //ASK JEFF HOW HE WANTS NULL VALUES TO BE HANDLED IN FOCUS.NAME KEY
      if (focus && focus.Name === null) {
        focus.Name = '';
      }

      if (focus.Name.toLowerCase().indexOf(nameToSearch.toLowerCase()) < 0) {
        delete newFilters[key];
      }
    });
    return newFilters;
  };

  const addNewFocus = () => {
    const focusTrimmed = newFocus.name.trim();
    if (focusTrimmed.length === 0) return;

    setIsUpdating(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'department/focus',
          { pk_Department: dContext.department.pk_Department },
          { Name: focusTrimmed },
          formatBearerToken(token),
        )
          .then((results) => {
            toast.success('Focus Added!');
            getFocuses();
            setNewFocus({ name: '' });
            setIsUpdating(false);
          })
          .catch((err) => {
            setIsUpdating(false);
            toast.error('Focus Failed to Add!');
          });
      })
      .catch((err) => {
        setIsUpdating(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const updateFocuses = (focus, cb) => {
    getTokenSilently()
      .then((token) => {
        putData(
          'department/focus',
          { pk_Department: dContext.department.pk_Department, pk_Focus: focus.pk_Focus },
          { Name: focus.Name },
          formatBearerToken(token),
        )
          .then((results) => {
            toast.success('Focus Updated!');
            getFocuses();
            if (cb) {
              cb();
            }
          })
          .catch((err) => {
            cb(err);
            toast.error('Focuses Failed to Update!');
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const onSave = (focus, cb) => {
    const newFocuses = JSON.parse(JSON.stringify(focuses));
    newFocuses[focus.index] = focus;
    setFocuses(newFocuses);
    updateFocuses(focus, cb);
  };

  const deleteDatabaseFocus = (pk_Focus) => {
    getTokenSilently()
      .then((token) => {
        deleteData(
          'department/focus',
          { pk_Department: dContext.department.pk_Department, pk_Focus: pk_Focus },
          null,
          formatBearerToken(token),
        )
          .then((results) => {
            toast.success('Focus Deleted!');
          })
          .catch((err) => {
            toast.error('Focus Delete failed!');
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const onDeleteFocus = (id) => {
    const newFocuses = focuses.filter((focus) => {
      return focus.pk_Focus !== id;
    });
    deleteDatabaseFocus(id);
    setFocuses(newFocuses);
  };
  const filteredFocuses = filterFocuses(focuses);
  /**********************************************/

  const isMobile = windowWidth < widthToSwitchToMobile;
  return (
    <CardBody>
      <div
        style={
          isMobile
            ? { display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }
            : { display: 'block', width: '100%' }
        }
      >
        <div style={{ width: '100%' }}>
          <InputGroup style={isMobile ? { width: '100%' } : {}}>
            <InputGroupText>
              <FontAwesomeIcon
                icon={faTimes}
                style={{ ...style.clickable }}
                onClick={() => {
                  setNameToSearch('');
                }}
              />
            </InputGroupText>

            <Input
              value={nameToSearch}
              type="text"
              placeholder="Search Focus. . ."
              onChange={(e) => {
                setNameToSearch(e.target.value);
              }}
              style={isMobile ? { width: '100%' } : {}}
            />

            <InputGroupText>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroupText>
          </InputGroup>
        </div>
        <div style={{ overflowY: 'scroll', height: '30vh', marginTop: 20, width: '100%' }}>
          {Object.keys(filteredFocuses).map((key, i) => {
            const focus = focuses[key];
            return <FocustItems key={key} focus={focus} index={i} onDeleteFocus={onDeleteFocus} onSave={onSave} />;
          })}
        </div>
        <div style={{ ...style.inputAndAddButtonContainer, width: '100%' }}>
          <div style={{ ...style.manageFieldsNewName, width: '100%' }}>
            <Input
              style={{ textAlign: 'left', width: '100%' }}
              placeholder="Add Focus. . ."
              value={newFocus.name}
              onChange={(e) => {
                const newName = e.target.value;
                setNewFocus((newFocus) => {
                  const newNewFocus = clone(newFocus);
                  return { ...newNewFocus, name: newName };
                });
              }}
              maxLength="55"
            />
          </div>
          <div>
            <Button
              color="success"
              disabled={isUpdating || newFocus.name.trim().length === 0}
              onClick={() => {
                addNewFocus();
              }}
            >
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </div>
        </div>
      </div>
    </CardBody>
  );
}

export default Focuses;
